import { Injectable } from '@angular/core';
import { LocalStorageService } from '@app/shared/services/local-storage';
import { IUser } from '@app/modules/user/interface/user';

const STORAGE_KEY = 'softhread-user';

@Injectable()
export class UserStorageService {

  /**
   * @param storage
   */
  public constructor(
    private readonly storage: LocalStorageService,
  ) {}

  public get(): IUser {
    return JSON.parse(this.storage.find(UserStorageService.storageKey));
  }

  public save(model: IUser): boolean {
    return this.storage.create(UserStorageService.storageKey, JSON.stringify(model));
  }

  public remove(): boolean {
    return this.storage.remove(UserStorageService.storageKey);
  }

  private static get storageKey(): string {
    return STORAGE_KEY;
  }
}
